import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
import _createClass from "/app/node_modules/babel-runtime/helpers/createClass";
export var ChannelApi = function () {
    function ChannelApi(axios, store) {
        _classCallCheck(this, ChannelApi);

        this.axios = axios;
    }

    _createClass(ChannelApi, [{
        key: "findAllChannel",
        value: function findAllChannel() {
            return this.axios.$get("/channels/channel/find-All-Channel");
        }
    }, {
        key: "findAllChannelByBoss",
        value: function findAllChannelByBoss(data) {
            return this.axios.$post("/channels/channel/fin-All-Channel-Boss/", data);
        }
    }, {
        key: "getChannelsManagement",
        value: function getChannelsManagement(data) {
            return this.axios.$post("/channels/channel/find-channel-management/", data);
        }
    }, {
        key: "createdNewChannel",
        value: function createdNewChannel(data) {
            return this.axios.$post("/channels/channel/new-channel", data);
        }
    }, {
        key: "editChannel",
        value: function editChannel(data) {
            return this.axios.$post("/channels/channel/edit-channel", data);
        }
    }, {
        key: "findChannelForEdit",
        value: function findChannelForEdit(data) {
            return this.axios.$post("/channels/channel/fin-channel-for-edit", data);
        }
    }, {
        key: "editChannelManagement",
        value: function editChannelManagement(data) {
            return this.axios.$post("/channels/channel/edit-channel-management", data);
        }
    }, {
        key: "validNewChannelName",
        value: function validNewChannelName(data) {
            return this.axios.$post("/channels/channel/valid-new-channel/", data);
        }
    }, {
        key: "validEditChannel",
        value: function validEditChannel(data) {
            return this.axios.$post("/channels/channel/valid-edit-channel/", data);
        }
    }]);

    return ChannelApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/channels.js
// module id = ./src/api/channels.js
// module chunks = 34